import React from 'react';
import './App.scss';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {BannersPage, EmployeesPage, LoginPage, ObjectsPage} from "src/pages";
import {Provider} from "react-redux";
import {store} from "src/redux/store";
import {AuthProvider} from "src/context/AuthContext";
import {ROUTES} from "src/consts/routes";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const router = createBrowserRouter([
  {
    path: ROUTES.LOGIN,
    element: <LoginPage />,
  },
  {
    path: ROUTES.EMPLOYEES,
    element: <EmployeesPage />,
  },
  {
    path: ROUTES.FACILITIES,
    element: <ObjectsPage />,
  },
  {
    path: ROUTES.BANNERS,
    element: <BannersPage />,
  },
]);

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
